


















import { Mixins, Component, Prop } from "vue-property-decorator";
import { PdfStyleDrawableMixin } from "../system/mixins";
import PdfViewer from "../system/viewers/PdfViewer.vue";
import { WindowFinder } from "../../components/system/utilities";

@Component({
  components: {
    PdfViewer,
  }
})
export default class PdfFileView extends Mixins(PdfStyleDrawableMixin) {
  @Prop({ default: "文書名：" })
  label: string;

  @Prop()
  name: string;

  @Prop()
  encodedUri: string;

  @Prop()
  isPrintable: boolean;

  @Prop()
  forceEnableOpenTypeFontFace: boolean;

  timer: any;
  mounted() {
    const intervalMilliSeconds = this.$configuration.behavior.document.previewWindow.parentWatchIntervalMilliSeconds;
    this.timer = setInterval(this.closeWindow, intervalMilliSeconds);
  }

  get unescapedName(): string {
    // Assistant経由(openアクション)で起動されるとAssistantのバグでnameがマルチバイトだとユニコード%エンコードされてくるのでunescapeするよう対処.
    // (ユニコード%エンコードされてなくても表示は可能.)
    // 今後同様のケースではAssistantを修正する方向で検討する事.
    // (今回は運用中の国がん中央への適用でAssistantとDocu2Web本体の同時更新が難しい可能性があるのでどっちでも行けるよう対応.)
    return unescape(this.name);
  }

  get pdfPath(): string {
    return decodeURIComponent(this.encodedUri);
  }

  closeWindow() {
    if (!WindowFinder.existsParentWindow()) {
      clearInterval(this.timer);
      this.$closeWindow(true);
    }
  }

  print(shouldSelectPrinter: boolean = false): void {
    if (!this.isPrintable) { return; }
    this.$printPdf(this.pdfPath, 1, shouldSelectPrinter);
  }

  close(): void {
    clearInterval(this.timer);
    this.$closeWindow();
  }
}
